import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DynamicFormControlService } from '@un-fao/lightforms-lib/lightforms-services';

@Component({
    selector: 'fishery-indicators',
    templateUrl: './indicators.component.html',
    styleUrl: './indicators.component.css',
    standalone: false
})
export class IndicatorsComponent implements OnInit
{
  @Input() title: string;
  @Input() collectionForm: any;
  @Input() items: Array<any>;
  @Input() summary: boolean = false;
  @Input() cssClass: string;

  public groups: any = {};
  public measures: any = {};
  public tables: Array<any> = [];
  public list: Array<any> = [];

  constructor(
    public dynamicFormControlService: DynamicFormControlService,
    private _decimalPipe: DecimalPipe
  ) {}
  
  ngOnInit(): void 
  {
    this.items = this.items.sort((a,b) => {

      if (a.type < b.type) return -1;
      if (a.type > b.type) return 1;

      if ((a.measure?.label || a.measure?.value) < (b.measure?.label || b.measure?.value)) return -1;
      if ((a.measure?.label || a.measure?.value) > (b.measure?.label || b.measure?.value)) return 1;

      if (a.timeframe < b.timeframe) return -1;
      if (a.timeframe > b.timeframe) return 1;

      return 0;
    });

    for(let i=0; i<this.items.length; i++)
    {
      if (this.items[i].tableTitle) 
      {
        if (!this.groups[this.items[i].tableTitle]) {
          this.groups[this.items[i].tableTitle] = [];
        }

        this.groups[this.items[i].tableTitle].push(this.items[i]);
      }
      else
      {        
        if (!this.items[i].measure && !this.items[i].freemeasure) 
        {
          this.list.push({
            type: this.items[i].type,
            text: this.items[i].indicatorText
          });
        }
        else if (!this.measures[this.items[i].measure?.label || this.items[i].measure?.value || this.items[i].freemeasure]) 
        {
          this.measures[this.items[i].measure?.label || this.items[i].measure?.value || this.items[i].freemeasure] = {
            type: this.items[i].type,
            class: this.items[i].class,
            items: []
          };
          
          this.measures[this.items[i].measure?.label || this.items[i].measure?.value || this.items[i].freemeasure].items.push(this.items[i]);
        }
        else 
        {
          this.measures[this.items[i].measure?.label || this.items[i].measure?.value || this.items[i].freemeasure].items.push(this.items[i]);
        }
      }
    }
    
    for(let key in this.groups) {
      this.tables.push({
        header: key,
        items: this.groups[key]
      });
    }

    for(let key in this.measures) {
      this.tables.push({
        header: key,
        class: this.measures[key].class,
        type: this.measures[key].type,
        items: this.measures[key].items
      });
    }

    console.log(this.tables);
  }

  showIndicatorText(table)
  {
    return table.items.filter(item => item.indicatorText > "").length > 0;
  }

  showTargetSpecies(table)
  {
    return table.items.filter(item => item.targetSpecies && (item.targetSpecies.label || item.targetSpecies.value)).length > 0;
  }

  decimalFormat(value) 
  {
    if (value && !isNaN(value)) 
    {
      value = this._decimalPipe.transform(value,'1.2-2');
      value = value.toString().replaceAll(',',' ');
      value = value.includes(".00") ? value.replace(".00","") : value;
    }

    return value;
  }
}
